import { render, staticRenderFns } from "./ContactButton.vue?vue&type=template&id=7536df2e&scoped=true&"
import script from "./ContactButton.vue?vue&type=script&lang=js&"
export * from "./ContactButton.vue?vue&type=script&lang=js&"
import style0 from "./ContactButton.vue?vue&type=style&index=0&id=7536df2e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7536df2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/keymetrics/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7536df2e')) {
      api.createRecord('7536df2e', component.options)
    } else {
      api.reload('7536df2e', component.options)
    }
    module.hot.accept("./ContactButton.vue?vue&type=template&id=7536df2e&scoped=true&", function () {
      api.rerender('7536df2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pricing/ContactButton.vue"
export default component.exports